import { NgZone, OnInit, Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { } from 'googlemaps';
import { User } from '../_models/index';
import { UserService, CookieService, MyOrderService } from '../_services/index';
import { forkJoin } from 'rxjs';
import { isJSDocNameReference } from 'typescript';

declare var $: any;
declare var gtag: Function;

@Component({
    moduleId: module.id,
    templateUrl: 'myorder.component.html',
    styleUrls: ['myorder.component.css']
})
export class MyorderComponent implements OnInit {
    currentUser: User;
    users: User[] = [];
    username = "Username";
    userId = "";
    sessionKey: string;
    orderConfirmation: string;
    filteredData: any = [];
    totalPage: any = [];
    pageData: any = [];
    currentPageNo = 1;
    months = ["", "JAN", "FEB", "MAR", "APL", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    years = [];
    currentMonth: number;
    date: string;
    urlData: any;
    reOrderMessage = '';
    orderData: any = [];
    ordersLoading: boolean = true;
    rangeSel: number = 0;

    // global variables for data service
    private _globalKey: string = '';
    private _dateFrom: string = '';
    private _dateTo: string = '';

    isUrls = [];
    dataRange = [];
    btnText = '<i class="fa fa fa-plus-square-o"></i>';

    contractors = [];
    isContractor: boolean;

    constructor(private router: Router, private ngZone: NgZone, private userService: UserService, private cookieService: CookieService, private myOrderService: MyOrderService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // gtag('js', new Date());
                // gtag('config', 'UA-65756200-2');
            }
        });
        if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("sessionKey"))) {
            this.userId = this.cookieService.getCookie('customerID');
            this.sessionKey = this.cookieService.getCookie("sessionKey");
            this.globalKey = sessionStorage.getItem('globalKey') || '';
            this.dateFrom = sessionStorage.getItem('dateFrom') || '';
            this.dateTo = sessionStorage.getItem('dateTo') || '';
            this.isContractor = sessionStorage.getItem('contractor') === 'Y';
            let startNo = "1";
            let endNo = "100";

            this.updateRecordRange(this.userId, this.sessionKey).then(() => {
                if (this.globalKey) {
                    this.LoadOrder(this.userId, startNo, endNo, this.globalKey, this.sessionKey);
                } else if (this.dateFrom || this.dateTo) {
                    if (!this.isValidDateRange()) {
                        this.toDateInvalid = false;
                        this.fromDateInvalid = false;
                        this.LoadOrder(this.userId, startNo, endNo, this.globalKey, this.sessionKey);
                    } else {
                        this.dateSelection();
                    }
                } else {
                    this.LoadOrder(this.userId, startNo, endNo, this.globalKey, this.sessionKey);
                }
            });
        }

        let currentTime = new Date()
        let year = currentTime.getFullYear();
        this.currentMonth = currentTime.getMonth();
        for (let i = 0; i < 10; i++) {
            this.years.push(year - i);
        }

        if (this.contractors.length == 0) {
            const call = this.myOrderService.getContractors(this.userId);
            call.subscribe((response) => {
                let obj = JSON.parse(response._body)
                for (let i = 0; i < obj.length; i++) {
                    this.contractors.push(obj[i])
                }
            })
        }
    }

    updateRecordRange(customerId: string, skey: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.myOrderService.getrangeorders(customerId, '1', '100', null, skey).subscribe(
                (data) => {
                    const totalNo = data.TOTAL;
                    this.dataRange = [];
                    let itemLength = Math.ceil(totalNo / 100);
                    let last = totalNo % 100;

                    for (let i = 0; i < itemLength; i++) {
                        let start = i * 100 + 1;
                        let end = start + 99;
                        if (i == itemLength - 1) {
                            end = start + last - 1;
                        }
                        if (last == 0) {
                            end = (i + 1) * 100;
                        }
                        let order = [start, end];
                        this.dataRange.push(order);
                    }
                    resolve(this.dataRange);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    LoadOrder(customerId: string, startNo: string, endNo: string, searchKey: string, skey: string) {
        this.ordersLoading = true;
        this.dateFrom = '';
        this.dateTo = '';

        this.myOrderService.getrangeorders(customerId, startNo, endNo, searchKey, skey).subscribe(
            (data) => {
                this.orderData = data.ORDERS;
                this.filteredData = data.ORDERS;
                this.pageData = this.filteredData.slice(0, 10);
                let total = Math.ceil(data.ORDERS.length / 10);
                let radius = 3;
                let current = 1;
                let order = [];
                for (let i = 1; i <= total; i++) {
                    if ((i >= 1 && i <= radius) || (i > (current - radius) && i < (current + radius)) || (i <= total && i > (total - radius))) {
                        order.push(i);
                    } else if (i == current - radius || i == current + radius) {
                        order.push("...");
                    }
                }
                this.totalPage = order;
                this.ordersLoading = false;
                this.ngZone.run(() => {
                    setTimeout(function () {
                        $(function () {

                            $('#data-table').DataTable();
                            let table = $('#data-table').DataTable();

                            table
                                .order([0, 'desc'])
                                .draw();
                        });
                    }, 10)
                })
            }
        )
    }

    getDownloadAllUrl(customerId: string, f: string, n: string, skey: string) {
        var numOfErrors = 0
        this.myOrderService.getdownloadUrl(customerId, f, n, skey).subscribe(
            data => {
                if (data.length) {
                    if (data.indexOf('Error') != -1) {
                        numOfErrors += 1;
                        return
                    } else {
                        window.open(data, "_blank")
                    }
                }
            }, (err) => {
                numOfErrors += 1
                console.log(err)
            })
        while (document.hidden) {}

        this.myOrderService.downloadAll(n).subscribe(
            data => {
                if (data.url) {
                    if (data.url.toLowerCase().indexOf('error') != -1) {
                        numOfErrors += 1
                        return
                    } else {
                        window.open(data.url, "_blank")
                    }
                }
            }, (error) => {
                numOfErrors += 1
                console.log(error);
            })

        if (numOfErrors >= 2) {
            alert("Error: no download links founded!");
        }
    }

    loadOnhold(customerId: string, orderid: string, skey: string) {
        this.myOrderService.getonholdGeom(customerId, orderid, skey).subscribe(result => {
            if (result == "") {
                alert("No order found!")
            } else {
                this.ngZone.run(() => {
                    this.cookieService.setCookieSession("onholdOrderId", orderid);
                    this.cookieService.setCookieSession("onholdEmail", result.email);
                    this.cookieService.setCookieSession("onholdType", result.geometry_type);
                    this.cookieService.setCookieSession("onholdGeom", result.geometry);
                    this.cookieService.setCookieSession("maxx", result.maxx);
                    this.cookieService.setCookieSession("minx", result.minx);
                    this.cookieService.setCookieSession("maxy", result.maxy);
                    this.cookieService.setCookieSession("miny", result.miny);
                })
                this.router.navigateByUrl('/onhold');
            }
        }, error => this.orderConfirmation = error);
    }

    ngOnInit() {
        this.btnText = '<i class="fa fa-plus-square-o"></i>';
    }

    rangeSelection() {
        this.orderData = [];

        $('#data-table').DataTable().destroy();;
        if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("sessionKey"))) {
            this.ordersLoading = true;
            this.userId = this.cookieService.getCookie('customerID');
            this.sessionKey = this.cookieService.getCookie("sessionKey");
            let startNo = this.dataRange[this.rangeSel][0];
            let endNo = this.dataRange[this.rangeSel][1];

            this.myOrderService.getrangeorders(this.userId, startNo, endNo, this.globalKey, this.sessionKey).subscribe(
                data => {

                    this.orderData = data.ORDERS;
                    this.filteredData = data.ORDERS;
                    this.pageData = this.filteredData.slice(0, 10);
                    let total = Math.ceil(data.ORDERS.length / 10);
                    let radius = 3;
                    let current = 1;
                    let order = [];
                    for (let i = 1; i <= total; i++) {
                        if ((i >= 1 && i <= radius) || (i > (current - radius) && i < (current + radius)) || (i <= total && i > (total - radius))) {
                            order.push(i);
                        } else if (i == current - radius || i == current + radius) {
                            order.push("...");
                        }
                    }
                    this.ordersLoading = false;
                    this.ngZone.run(() => {
                        setTimeout(function () {
                            $(function () {
                                $('#data-table').DataTable();
                                let table = $('#data-table').DataTable();

                                table
                                    .order([0, 'desc'])
                                    .draw();
                            });
                        }, 1)
                    })
                }
            );
        }
    }

    fromDateInvalid = false;
    toDateInvalid = false;
    isValidDateRange() {
        this.fromDateInvalid = false;
        this.toDateInvalid = false;

        this.fromDateInvalid = !this.dateFrom;
        this.toDateInvalid = !this.dateTo;

        let dateFrom = null;
        if (this.dateFrom) {
            dateFrom = new Date(this.dateFrom);
        }

        let dateTo = null;
        if (this.dateTo) {
            dateTo = new Date(this.dateTo);
        }

        const today = new Date();

        if (dateFrom && dateTo && dateFrom > dateTo) {
            this.fromDateInvalid = true;
            this.toDateInvalid = true;
        }

        if (dateFrom > today) {
            this.fromDateInvalid = true;
        }

        if (dateTo > today) {
            this.toDateInvalid = true;
        }

        return !(this.fromDateInvalid || this.toDateInvalid);
    }

    dateSelection(changeRangeSel?: boolean) {
        this.globalKey = '';

        if (this.isValidDateRange() == false) return;

        this.orderData = [];
        let dateFrom = new Date(this.dateFrom + 'T12:00');
        let dateTo = new Date(this.dateTo + 'T12:00');
        let formattedDateFrom = dateFrom.getDate() + '-' + dateFrom.toLocaleString('default', { month: 'short' }).toUpperCase() + '-' + dateFrom.getFullYear().toString().substr(-2);
        let formattedDateTo = dateTo.getDate() + '-' + dateTo.toLocaleString('default', { month: 'short' }).toUpperCase() + '-' + dateTo.getFullYear().toString().substr(-2);


        $('#data-table').DataTable().destroy();
        if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("sessionKey"))) {
            this.ordersLoading = true;
            this.userId = this.cookieService.getCookie('customerID');
            this.sessionKey = this.cookieService.getCookie("sessionKey");
            if (!changeRangeSel) {
                this.rangeSel = 0;
            }
            let startNo = this.dataRange[this.rangeSel][0];
            let endNo = this.dataRange[this.rangeSel][1];

            let orderData = {
                "PROCEDURE": "getDateRangeOrders",
                "CUSTOMER_ID": this.userId,
                "START": startNo,
                "END": endNo,
                "FROM_DATE": formattedDateFrom,
                "TO_DATE": formattedDateTo
            };

            this.myOrderService.serviceCall1(JSON.stringify(orderData)).subscribe(
                (response: any) => {
                    let data = JSON.parse(response._body);
                    if (!changeRangeSel) {
                        this.orderData = data.ORDERS;
                        this.ordersLoading = false;
                        this.ngZone.run(() => {
                            setTimeout(function () {
                                $(function () {
                                    $('#data-table').DataTable();
                                    let table = $('#data-table').DataTable();

                                    table
                                        .order([0, 'desc'])
                                        .draw();
                                });
                            }, 1)
                        })
                    } else {
                        this.orderData = data.ORDERS;
                        this.filteredData = data.ORDERS;
                        this.pageData = this.filteredData.slice(0, 10);
                        let total = Math.ceil(data.ORDERS.length / 10);
                        let radius = 3;
                        let current = 1;
                        let order = [];
                        for (let i = 1; i <= total; i++) {
                            if ((i >= 1 && i <= radius) || (i > (current - radius) && i < (current + radius)) || (i <= total && i > (total - radius))) {
                                order.push(i);
                            } else if (i == current - radius || i == current + radius) {
                                order.push("...");
                            }
                        }
                        this.ordersLoading = false;
                        this.ngZone.run(() => {
                            setTimeout(function () {
                                $(function () {
                                    $('#data-table').DataTable();
                                    let table = $('#data-table').DataTable();

                                    table
                                        .order([0, 'desc'])
                                        .draw();
                                });
                            }, 1)
                        })
                    }
                }
            );
        }
    }

    globalFilter(value): void {
        this.dateFrom = '';
        this.dateTo = '';
        this.orderData = [];

        $('#data-table').DataTable().destroy();;
        if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("sessionKey"))) {
            this.ordersLoading = true;
            this.userId = this.cookieService.getCookie('customerID');
            this.sessionKey = this.cookieService.getCookie("sessionKey");
            this.rangeSel = 0;
            let startNo = this.dataRange[this.rangeSel][0];
            let endNo = this.dataRange[this.rangeSel][1];
            let searchKey = value;

            this.myOrderService.getrangeorders(this.userId, startNo, endNo, searchKey, this.sessionKey).subscribe(
                data => {

                    this.orderData = data.ORDERS;
                    this.ordersLoading = false;
                    this.ngZone.run(() => {
                        setTimeout(function () {
                            $(function () {
                                $('#data-table').DataTable();
                                let table = $('#data-table').DataTable();

                                table
                                    .order([0, 'desc'])
                                    .draw();
                            });
                        }, 1)
                    })
                });
        }
    }

    clearFilter() {
        this.orderData = [];
        $('#data-table').DataTable().destroy();
        this.rangeSel = 0;
        this.globalKey = '';
        this.dateFrom = '';
        this.dateTo = '';
        let startNo = this.dataRange[this.rangeSel][0];
        let endNo = this.dataRange[this.rangeSel][1];

        if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("sessionKey"))) {
            this.userId = this.cookieService.getCookie('customerID');
            this.sessionKey = this.cookieService.getCookie("sessionKey");

            this.LoadOrder(this.userId, startNo, endNo, this.globalKey, this.sessionKey);
        }
    }

    toTableView() {

        $("#tableView").css("display", "block");
        $("#listView").css("display", "none");
        let btns = document.getElementsByClassName("switchBtn");

        btns[1].className = btns[1].className.replace("active", "");
        btns[0].className += " active";
    }

    toListView() {
        $("#listView").css("display", "block");
        $("#tableView").css("display", "none");
        let btns = document.getElementsByClassName("switchBtn");
        btns[0].className = btns[0].className.replace("active", "");
        btns[1].className += " active";
        $("#page1").trigger("click");
    }

    toOrdersummary(order) {

        this.cookieService.setCookieSession('orderSummary', order);
    }

    toOnhold(order) {
        this.loadOnhold(this.userId, order, this.sessionKey);
    }

    sortData(key) {
        let sortByPropertyA = function (property) {
            return function (x, y) {
                if (x[property] === y[property]) {
                    return 0;
                } else {
                    return (x[property] > y[property]) ? 1 : -1;
                }
            };
        };
        let sortByPropertyD = function (property) {
            return function (x, y) {
                if (x[property] === y[property]) {
                    return 0;
                } else {
                    return (x[property] < y[property]) ? 1 : -1;
                }
            };
        };

        if ((key == 'DATE_RECEIVED') || (key == 'ORDER_NUM')) {
            this.filteredData.sort(sortByPropertyD(key));
        } else {
            this.filteredData.sort(sortByPropertyA(key));
        }
        this.pageData = this.filteredData.slice(0, 10);
        $('.pageNo').each(function () {
            $(this).removeClass("active");
        })

        $("#page1").addClass('active');
    }

    filterData(keyString) {
        let substring = keyString.toUpperCase();
        this.filteredData = this.orderData.filter(function (el) {
            let allProname = "";
            for (let pro of el.PRODUCTS) {
                allProname += pro.PRODUCT_NAME;
            }

            return ((el.ORDER_NUM.toUpperCase()).indexOf(substring) != -1) ||
                ((el.SITE_NAME.toUpperCase()).indexOf(substring) != -1) ||
                ((el.ADDRESS1.toUpperCase()).indexOf(substring) != -1) ||
                ((el.CITY.toUpperCase()).indexOf(substring) != -1) ||
                ((el.PROVSTATE.toUpperCase()).indexOf(substring) != -1) ||
                ((el.DATE_RECEIVED.toUpperCase()).indexOf(substring) != -1) ||
                ((el.STATUS.toUpperCase()).indexOf(substring) != -1) ||
                ((el.ASSIGNED_USER.toUpperCase()).indexOf(substring) != -1) ||
                ((allProname.toUpperCase()).indexOf(substring) != -1)
        });


        let total = Math.ceil(this.filteredData.length / 10);
        this.totalPage = [];
        for (let i = 0; i < (total); i++) {
            this.totalPage.push(i + 1);
        }
        this.pageData = this.filteredData.slice(0, 10);
        $('.pageNo').each(function () {
            $(this).removeClass("active");
        })

        $("#page1").addClass('active');
        this.currentPageNo = 1;

        let radius = 3;
        let current = this.currentPageNo;
        let order = [];
        for (let i = 1; i <= total; i++) {
            if ((i >= 1 && i <= radius) || (i > (current - radius) && i < (current + radius)) || (i <= total && i > (total - radius))) {
                order.push(i);
            } else if (i == current - radius || i == current + radius) {
                order.push("...");
            }
        }
        this.totalPage = order;
    }

    changePage(i) {
        if (i == "...") {
            return;
        }
        this.currentPageNo = i;

        $('.pageNo').each(function () {
            $(this).removeClass("active");
        })
        $(event.target).addClass('active');

        this.pageData = this.filteredData.slice((i - 1) * 10, (i * 10));
        let total = Math.ceil(this.filteredData.length / 10);
        let radius = 3;
        let current = this.currentPageNo;
        let order = [];
        for (let i = 1; i <= total; i++) {
            if ((i >= 1 && i <= radius) || (i > (current - radius) && i < (current + radius)) || (i <= total && i > (total - radius))) {
                order.push(i);
            } else if (i == current - radius || i == current + radius) {
                order.push("...");
            }
        }
        this.totalPage = order;
    }

    prePage() {
        if (this.currentPageNo > 1) {
            let i = this.currentPageNo - 1;
            this.pageData = this.filteredData.slice((i - 1) * 10, (i * 10));
            $('.pageNo').each(function () {
                $(this).removeClass("active");
            })
            let id = '#page' + i;
            $(id).addClass('active');
            this.currentPageNo = i;
            this.pageData = this.filteredData.slice((i - 1) * 10, (i * 10));
            let total = Math.ceil(this.filteredData.length / 10);
            let radius = 3;
            let current = this.currentPageNo;
            let order = [];
            for (let i = 1; i <= total; i++) {
                if ((i >= 1 && i <= radius) || (i > (current - radius) && i < (current + radius)) || (i <= total && i > (total - radius))) {
                    order.push(i);
                } else if (i == current - radius || i == current + radius) {
                    order.push("...");
                }
            }
            this.totalPage = order;
        }
    }

    nextPage() {
        let total = Math.ceil(this.filteredData.length / 10);
        if (this.currentPageNo < total) {
            let i = this.currentPageNo + 1;
            this.pageData = this.filteredData.slice((i - 1) * 10, (i * 10));
            $('.pageNo').each(function () {
                $(this).removeClass("active");
            })
            let id = '#page' + i;
            $(id).addClass('active');
            this.currentPageNo = i;
            this.pageData = this.filteredData.slice((i - 1) * 10, (i * 10));
            let total = Math.ceil(this.filteredData.length / 10);
            let radius = 3;
            let current = this.currentPageNo;
            let order = [];
            for (let i = 1; i <= total; i++) {
                if ((i >= 1 && i <= radius) || (i > (current - radius) && i < (current + radius)) || (i <= total && i > (total - radius))) {
                    order.push(i);
                } else if (i == current - radius || i == current + radius) {
                    order.push("...");
                }
            }
            this.totalPage = order;
        }
    }


    getUrl(f, n, event): void {



        if (event.target.value == "") {
            this.getDownloadAllUrl(this.userId, f, n, this.sessionKey);
        } else {
            this.urlData = event.target.value;
        }
    }


    thisOrderNum;

    addOrderToCart(orderno): void {

        let inputJson = { "PROCEDURE": "addOrderToCart", "CUSTOMER_ID": this.userId, "ORDER_NUM": orderno };

        this.thisOrderNum = orderno;
        this.myOrderService.serviceCall1(JSON.stringify(inputJson)).subscribe((response: any) => {
            if (response._body == "Y") {
                console.log("success!", response.statusText);
                this.reOrderMessage = 'Order has been placed to your cart successfully.';
            }

            else {
                console.log("failed!", response.statusText);
                this.reOrderMessage = response._body.slice(6);
            }
        });
    }

    clearAllfilter(): void {
        $('#sort').prop("selectedIndex", 0);
        $("#filter").val("");
        let pageNo = "null";
        let total = "null";
        let key = "";
        this.date = "";
        this.filterData("");
        this.sortData('ORDER_NUM');
    }

    trackByFn(index, item) {
        return index;
    }

    openUrlList(id, bid): void {
        let selector = "#" + bid;
        let iselector = "#" + bid + ' i';
        let classSelector = "." + id;
        $(iselector).toggleClass("fa-plus-square-o fa-minus-square-o");
        if ($(selector).next('div').css('display') != "none") {
            $(selector).next('div').css('display', 'none');
        } else {
            $(classSelector).each(function () {
                if ($(this).css('display') == 'block') {
                    $(this).css('display', 'none');
                    let idstring = $(this).attr('id');
                    let btnstring = '#' + idstring.replace('xsxsxsxs', 'button') + ' i';
                    $(btnstring).toggleClass("fa-plus-square-o fa-minus-square-o");
                }
            })
            $(selector).next('div').css('display', 'block');
        }
    }

    openUrlListView(id, bid): void {
        let selector = "#" + bid;
        let iselector = "#" + bid + ' i';
        let classSelector = "." + id;
        $(iselector).toggleClass("fa-plus-square-o fa-minus-square-o");
        if ($(selector).next('div').css('display') != "none") {
            $(selector).next('div').css('display', 'none');
        } else {
            $(classSelector).each(function () {
                if ($(this).css('display') == 'block') {
                    $(this).css('display', 'none');
                    let idstring = $(this).attr('id');
                    let btnstring = '#' + idstring.replace('listxsxsxsxs', 'listbutton') + ' i';
                    $(btnstring).toggleClass("fa-plus-square-o fa-minus-square-o");
                }
            })
            $(selector).next('div').css('display', 'block');
        }
    }


    DownloadAllOrders() {
        if (this.ordersLoading) return;
        this.ordersLoading = true
        let rows = (document.querySelectorAll('tr[role = "row"]'))
        let i = 0
        rows.forEach(row => {
            if (row.id && i < 20) {
                i++ 
                const order = JSON.parse(row.id)
                const observableOrder = this.myOrderService.getdownloadUrl(this.userId, order.FOLDER_NAME, order.ORDER_NUM, this.sessionKey);
                const observableMobile = this.myOrderService.downloadAll(order.ORDER_NUM)
                
                while (document.hidden) {}
                observableOrder.subscribe(response => {
                    if (response.length) {
                        if (response.indexOf('Error') !== -1) {
                            return;
                        } else {
                            window.open(response, "_blank")
                        }
                    } else {
                        console.log(`Error: no download link found for item ${0 + 1}`);
                    }
                }, (error) => {
                })

                while (document.hidden) {}
                observableMobile.subscribe(response => {
                    if (response.url) {
                        if (response.url.toLowerCase().indexOf('error') !== -1) {
                            return;
                        }
                        else {
                            window.open(response.url, "_blank")
                        }
                    } else {
                        console.log(`Error: no download link found for item ${0 + 1}`);
                    }
                },(error) => {
                })
            }
        })
        this.ordersLoading = false
    }

    updateContractorOrderData(orderNo, order) {
        for (let i = 0; i < this.orderData.length; i++) {
            if (this.orderData[i].ORDER_NUM === orderNo) {
                this.orderData[i].CONTRACTOR_ORDER = JSON.parse(order).CONTRACTOR_ORDER
                this.orderData[i].CONTRACTOR = JSON.parse(order).CONTRACTOR
            }
        }
    }

    openAssign() {
        if (this.contractors.length == 0) {
            const call = this.myOrderService.getContractors(this.userId);
            call.subscribe((response) => {
                let obj = JSON.parse(response._body)
                for (let i = 0; i < obj.length; i++) {
                    this.contractors.push(obj[i])
                }
            })
        }
    }

    assignContractor(contractor, orderNo: string) {
        const call = this.myOrderService.assignContractor(this.userId, contractor.CUSTOMER_ID, orderNo);
        call.subscribe((response: any) => {
            this.updateContractorOrderData(orderNo, response._body)
        })
    }

    removeContractor(contractor, orderNo: string) {
        const call = this.myOrderService.removeContractor(this.userId, contractor.CUSTOMER_ID, orderNo);
        call.subscribe((response: any) => {
            this.updateContractorOrderData(orderNo, response._body)
        })
    }

    handleContractor(contractor, orderNo: string, orderContractor) {
        if (orderContractor === "") {
            this.assignContractor(contractor, orderNo)
        } else if (orderContractor.CUSTOMER_ID !== contractor.CUSTOMER_ID) {
            this.removeContractor(orderContractor, orderNo)
            this.assignContractor(contractor, orderNo)
        } else {
            this.removeContractor(orderContractor, orderNo)
        }
    }

    get globalKey() {
        return sessionStorage.getItem('globalKey');
    }

    set globalKey(value: string) {
        sessionStorage.setItem('globalKey', value);
    }

    get dateFrom() {
        return sessionStorage.getItem('dateFrom');
    }

    set dateFrom(value: string) {
        sessionStorage.setItem('dateFrom', value);
    }

    get dateTo() {
        return sessionStorage.getItem('dateTo');
    }

    set dateTo(value: string) {
        sessionStorage.setItem('dateTo', value);
    }

}